// extracted by mini-css-extract-plugin
export var growableInput = "_a4-0";
export var tagContainer = "_a4-2";
export var textInput = "_a4-1";